import { ITree } from '../../../utils/itree'
import { Container } from 'pixi.js'

// TODO2 Mike: see comments in "ITree.ts"

export class ContainerTreeAdaptor implements ITree {
	name: string
	childCount: number
	container: Container
	constructor(container: Container) {
		this.container = container
		this.name = `${container.name} (${container.constructor.name}) (${container.x},${container.y})`
		this.childCount = container.children.length
	}
	getChild(i: number): ITree {
		const child = this.container.children[i]
		if (child as Container) {
			return new ContainerTreeAdaptor(child as Container)
		}
	}
}
